import { FC } from 'react';
import { AdminCardSettings } from 'containers/admin';
import { AdminCardLayout } from 'pages/atoms';

const AdminCardSettingsPage: FC = () => {
  return (
    <AdminCardLayout>
      <AdminCardSettings />
    </AdminCardLayout>
  );
};

export default AdminCardSettingsPage;
